import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { customerQuery } from "../shell/shell-tabs";
import { PanelHead } from "./PanelHead";

/**
 * The counter in one place, as iOS's segmented control: the customers' scans,
 * their carts, and the QR that brings them in. The selected tab is a lighter
 * fill, not the accent, which the actions on the page keep. The customer
 * served rides along, so Scans goes back to them, as iOS's segment does. A
 * pane's own action (from 640 px, where it no longer floats) goes at the head's
 * end.
 */
export function CustomerTabs({
  active,
  openCarts,
  action,
  customer = null,
}: {
  active: "scans" | "carts" | "qr";
  openCarts: number;
  action?: ReactNode;
  customer?: string | null;
}) {
  const q = customerQuery(customer);
  const tab = (on: boolean) =>
    `flex flex-1 items-center justify-center gap-1.5 rounded-btn px-3 py-2 text-sm font-medium transition-colors sm:flex-none ${
      on ? "bg-surface-strong text-white" : "text-muted hover:text-white"
    }`;
  return (
    <PanelHead className="mb-6" action={action}>
      <h1 className="text-lg font-bold text-white">Customer</h1>
      <nav className="flex w-full gap-1 rounded-btn bg-surface p-1 sm:w-auto" aria-label="Customer">
        <Link
          to={`/customer-scans${q}`}
          className={tab(active === "scans")}
          aria-current={active === "scans" ? "page" : undefined}
        >
          Scans
        </Link>
        <Link
          to={`/customer-carts${q}`}
          className={tab(active === "carts")}
          aria-current={active === "carts" ? "page" : undefined}
        >
          Carts
          {openCarts > 0 && (
            <span className="inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-accent px-1 text-[10px] font-semibold text-ink">
              {openCarts > 99 ? "99+" : openCarts}
              <span className="sr-only"> open</span>
            </span>
          )}
        </Link>
        <Link
          to={`/customer-qr${q}`}
          className={tab(active === "qr")}
          aria-current={active === "qr" ? "page" : undefined}
        >
          Shop QR
        </Link>
      </nav>
    </PanelHead>
  );
}
